import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector   : 'wor-intelligence-kpi-card',
  template: require('./intelligence.kpi-card.component.html')
})
export class KpiCardComponent {
  @Input() band      : string;
  @Input() caption   : string = '';
  @Input() clickable : boolean = false;
  @Input() delta     : number | null;
  @Input() invert    : boolean = false;
  @Input() label     : string = '';
  @Input() link      : string;
  @Input() loading   : boolean = false;
  @Input() value     : string = '';

  @Output() pressed = new EventEmitter<void>();

  deltaMagnitude () : string {
    return Math.abs(this.delta || 0).toFixed(1);
  }

  press () : void {
    if ( this.clickable ) {
      this.pressed.emit();
    }
  }

  isNegative () : boolean {
    return this.delta !== null
      && this.delta !== undefined
      && ( this.invert
        ? this.delta > 0
        : this.delta < 0 );
  }

  isPositive () : boolean {
    return this.delta !== null
      && this.delta !== undefined
      && ( this.invert
        ? this.delta < 0
        : this.delta > 0 );
  }
}
